import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-subsidy-wallet',
  templateUrl: './subsidy-wallet.component.html',
  styleUrls: ['./subsidy-wallet.component.scss'],
})
export class SubsidyWalletComponent implements OnInit {
  @Input() public subsidyAmount: number = 0;

  @Output() public readonly infoClicked = new EventEmitter<void>();
  @Output() public readonly ctaClicked = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {   
    return;
  }
}
